class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    this.querySelectorAll('[data-myd-search-close], button[type="button"].myd-search__back, button[type="button"].search__button').forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });

    const resetBtn = this.querySelector('button[type="reset"]');
    if (resetBtn) resetBtn.addEventListener('click', this.reset.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Fullscreen shell on mobile — back button closes; desktop allows outside-click.
    if (this.querySelector('.myd-search-shell') && window.innerWidth < 990) return;
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    const focusRoot = this.detailsContainer.querySelector('.myd-search') || this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (focusRoot && focusInput) trapFocus(focusRoot, focusInput);
    else if (focusInput) focusInput.focus();

    if (window.MYDSearchRecent) window.MYDSearchRecent.renderAll();
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    const input = this.querySelector('input[type="search"]');
    if (input) input.value = '';
  }
}

customElements.define('search-modal', SearchModal);
